
import { Button } from '@/components/ui/button';
import { UserPlus, RefreshCw } from 'lucide-react';
import { Organization } from '@/types/auth';

interface OrganizationUsersHeaderProps {
  organization: Organization | null;
  onInviteUser: () => void;
  onRefresh: () => void;
  refreshing: boolean;
}

export function OrganizationUsersHeader({ 
  organization, 
  onInviteUser, 
  onRefresh, 
  refreshing 
}: OrganizationUsersHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          {organization ? `${organization.name} Team` : 'Team Members'}
        </h1>
        <p className="text-muted-foreground">
          Manage your organization's team members and their roles
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={refreshing}
        >
          <RefreshCw className={`mr-2 h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        <Button onClick={onInviteUser}>
          <UserPlus className="mr-2 h-4 w-4" />
          Invite Team Member
        </Button>
      </div>
    </div>
  );
}
